/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedModelTenderResponseModel } from '../../models/paged-model-tender-response-model';

export interface ListTenders1$Params {
  merchantId: string;
}

export function listTenders1(http: HttpClient, rootUrl: string, params: ListTenders1$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelTenderResponseModel>> {
  const rb = new RequestBuilder(rootUrl, listTenders1.PATH, 'get');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelTenderResponseModel>;
    })
  );
}

listTenders1.PATH = '/merchants/{merchantId}/tenders';
